// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';

const fragments = {
  TOOLS_SHARE: '[data-fragment="News.toolsShare"]',
  TOOLS_LIKE: '[data-fragment="News.toolsLike"]',
  IMAGE_CONTAINER: '[data-fragment="News.imageContainer"]',
  ITEM: '[data-fragment="News.item"]',
  SHOW_ALL_CONTENT: '[data-fragment="News.showAllContent"]',
  NEWS_GET_SI: '/api/bn-news/bnNews/adam/container/getStatisticalInfo',
  NEWS_PUT_SI: '/api/bn-news/bnNews/adam/container/putStatisticalInfo',
};

export default class News extends WebComponent {
  constructor(props) {
    super(props);
    this.props = props;
  }

  didMount() {

    document.addEventListener('scroll', () => {
      const pagination = document.querySelector("[data-is='UniversalPaginationButton']");
      if (pagination) {
        const paginationRect = pagination.getBoundingClientRect();
        if (paginationRect.top < window.innerHeight && paginationRect.bottom > 0) {
			if(pagination.getAttribute('data-clicked') !== 'true') {
				pagination.setAttribute('data-clicked', 'true');
          		pagination.click();
			}
        }
      }
    });

	this.pushTrafficAcquisition();

    this.initToolsLike();
    this.initToolsShare();
    this.initItemPerex();
    this.initItemsStatistics().then(r => r);

    this.on('click', fragments.TOOLS_LIKE, this.handleClickOnToolsLike.bind(this));
    this.on('dblclick', fragments.ITEM, this.handleClickOnToolsLike.bind(this));
    this.on('click', fragments.SHOW_ALL_CONTENT, this.handleClickOnShowAllContent.bind(this));

	  $(document).on('afterContentsReplaced', () => {
		  if(this.element) {
			  this.initToolsLike();
			  this.initToolsShare();
			  this.initItemPerex();
			  this.initItemsStatistics().then(r => r);
		  }
	  });
  }

  pushTrafficAcquisition = () => {
	  const url = new URL(window.location.href);
	  const utmMedium = url.searchParams.get("utm_medium");
	  if(utmMedium) {
		  dataLayer.push({
			'event': 'traffic_acquisition',
			'traffic_acquisition': {
			  'source': 'qr',
			  'medium': utmMedium
			},
			_clear: true
		  });
		// url.searchParams.delete("utm_medium");
		// window.history.replaceState({}, document.title, url);
	  }
  }

  initToolsShare = () => {
	  this.toolsShareElements = this.element.querySelectorAll(fragments.TOOLS_SHARE);
	  this.toolsShareElements.forEach((element) => {
		  if (!element.hasAttribute('data-init')) {
			  element.setAttribute('data-init', 'true');
			  const parentItem = element.closest(fragments.ITEM);
			  const dataUrl = parentItem.getAttribute('data-url');
			  const dataTitle = parentItem.querySelector('.news__title');
			  const dataPerex = parentItem.querySelector('.news__perex');
			  // eslint-disable-next-line no-undef
			  if (navigator.share) {
				  const shareData = {
					  title: dataTitle ? dataTitle.innerText : '',
					  text: dataPerex ? dataPerex.innerText : '',
					  // eslint-disable-next-line no-undef
					  url: window.location.origin + dataUrl,
				  };
				  element.addEventListener('click', e => this.handleClickOnToolsShare(e, shareData));
			  } else {
				  element.classList.add('hidden');
			  }
		  }
	  });
  }

  initToolsLike = () => {
	  this.toolsLikeElements = this.element.querySelectorAll(fragments.TOOLS_LIKE);
	  this.toolsLikeElements.forEach((element) => {
		  if (!element.hasAttribute('data-init')) {
			  element.setAttribute('data-init', 'true');
			  const parentItem = element.closest(fragments.ITEM);
			  const newsId = parentItem.getAttribute('data-id');
			  const isActive = localStorage.getItem(`${newsId}_like`);
			  if (isActive === 'true') {
				  element.classList.add('active');
			  }
		  }
	  });
  }

  initItemPerex = () => {
	  const newsItems = this.element.querySelectorAll(fragments.ITEM);
	  newsItems.forEach((item) => {
		  const newsPerex = item.querySelector('.news__perex');
		  const hasQuiz = item.querySelector('.quiz');
		  if (newsPerex && !newsPerex.classList.contains('news__perex--init')) {
			  newsPerex.classList.add('news__perex--init');
			  if (newsPerex.innerText.length > 150) {
				  const originalHtml = newsPerex.innerHTML;
				  newsPerex.innerHTML = `${newsPerex.innerText.substring(0, 150)}<span class="hellip">...</span>`;
				  const showAllContent = document.createElement('div');
				  showAllContent.classList.add('news__full-content');
				  showAllContent.innerHTML = originalHtml;
				  newsPerex.appendChild(showAllContent);
				  const showAllContentBtn = document.createElement('span');
				  showAllContentBtn.classList.add('news__show-all-content');
				  showAllContentBtn.innerHTML = '&nbsp;<span data-fragment="News.showAllContent">číst dál</span>';
				  newsPerex.appendChild(showAllContentBtn);
				  showAllContentBtn.addEventListener('click', this.handleClickOnShowAllContent);
			  }
			  if(hasQuiz && newsPerex.innerText.length < 150) {
				  const showAllContentBtn = document.createElement('span');
				  showAllContentBtn.classList.add('news__show-all-content');
				  showAllContentBtn.innerHTML = '&nbsp;<span data-fragment="News.showAllContent">číst dál</span>';
				  newsPerex.appendChild(showAllContentBtn);
				  showAllContentBtn.addEventListener('click', this.handleClickOnShowAllContent);
			  }
		  }
	  });
  }

  initItemsStatistics = async () => {
    const newsItems = this.element.querySelectorAll(fragments.ITEM);
    newsItems.forEach((item) => {
		if (!item.hasAttribute('data-init-statistics')) {
			item.setAttribute('data-init-statistics', 'true');
			const newsId = item.getAttribute('data-id');
			// eslint-disable-next-line no-undef
		  fetch(`${window.location.origin + fragments.NEWS_GET_SI}?news_id=${newsId}`).then((response) => {
			  const contentType = response.headers.get('content-type');
			  if (!contentType || !contentType.includes('application/json')) {
				  return null;
			  }
				response.json().then(r => this.showToolsCount(item, r.like_count));
		  });
		}
    });
  }

  showToolsCount = (item, count) => {
	  const likeCountElement = item.querySelector('.news__tools-count');
	  likeCountElement.classList.remove('hidden');
	  // eslint-disable-next-line radix
	  if (count != null) {
		  likeCountElement.innerText = count;
	  } else {
		  const likeCount = parseInt(likeCountElement.innerText);
		  if (likeCountElement.parentElement.classList.contains('active')) {
			  likeCountElement.innerText = likeCount + 1;
		  } else {
			  likeCountElement.innerText = likeCount - 1;
		  }
	  }
	  if (likeCountElement.innerText === '0') {
		  likeCountElement.classList.add('hidden');
	  }
  }


  handleClickOnShowAllContent = (e) => {
	  const parentItem = e.target.closest(fragments.ITEM);
	  if (parentItem) {
		  const newsPerex = parentItem.querySelector('.news__perex');
		  const newsQuiz = parentItem.querySelector('.quiz');
		  const newsFullContent = parentItem.querySelector('.news__full-content');
		  const newsShowAllContent = parentItem.querySelector('.news__show-all-content');
		  const newsShowAllContentArrow = parentItem.querySelector('.news__show-all-content-arrow');
		  if(newsFullContent) {
		  	newsPerex.innerHTML = newsFullContent.innerHTML;
		  }
		  if (newsShowAllContentArrow) {
		  	newsShowAllContentArrow.remove();
		  }
		  if(newsQuiz) {
			newsQuiz.classList.add('quiz--show');
			newsShowAllContent.remove();
		  }
	  }
  }

  handleClickOnToolsShare = async (e, shareData) => {
	  try {
		  // eslint-disable-next-line no-undef
		  await navigator.share(shareData);
		  const parentItem = e.target.closest(fragments.ITEM);
		  const newsId = parentItem.getAttribute('data-id');
		  const newsUrl = parentItem.getAttribute('data-url');
		  fetch(`${window.location.origin + fragments.NEWS_GET_SI}?news_id=${newsId}`).then((response) => {
			  // eslint-disable-next-line no-mixed-spaces-and-tabs
			  const contentType = response.headers.get('content-type');
			  if (!contentType || !contentType.includes('application/json')) {
				  const bodyData = {
					  news_id: newsId,
					  share_count: 1,
				  };
				  this.putData(bodyData);
				  return null;
			  }
				  response.json().then((r) => {
					  const shareCount = parseInt(r.share_count ? r.share_count : 0);
					  if (shareCount >= 0) {
						  const bodyData = {
							  id: r.id,
							  share_count: shareCount + 1,
						  };
						  this.putData(bodyData);
					  }
				  });
		  });

		  window.dataLayer.push({
			  event: 'click_icon',
			  click_icon: {
				  name: 'share',
				  area: 'body',
				  url: window.location.origin + newsUrl,
				  type: 'vlastovka',
			  },
			  _clear: true,
		  });
    } catch (err) {
	  console.log(`Error: ${err}`);
    }
  }

  handleClickOnToolsLike = (e) => {
    e.preventDefault();
    const parentItem = e.target.closest(fragments.ITEM);
    if (parentItem) {
      const isActive = parentItem.querySelector(fragments.TOOLS_LIKE).classList.toggle('active');
      const newsId = parentItem.getAttribute('data-id');
      const newsUrl = parentItem.getAttribute('data-url');

		  localStorage.setItem(`${newsId}_like`, isActive);
      // eslint-disable-next-line no-undef
      fetch(`${window.location.origin + fragments.NEWS_GET_SI}?news_id=${newsId}`).then((response) => {
		  // eslint-disable-next-line no-mixed-spaces-and-tabs
		  const contentType = response.headers.get('content-type');
		  if (!contentType || !contentType.includes('application/json')) {
          const bodyData = {
			  news_id: newsId,
			  like_count: 1,
          };
          this.putData(bodyData);
          return null;
		  }
		  response.json().then((r) => {
          const likeCount = parseInt(r.like_count ? r.like_count : 0);
          if (likeCount >= 0) {
			  const bodyData = {
              id: r.id,
              like_count: isActive ? likeCount + 1 : likeCount - 1,
			  };
			  this.putData(bodyData);
          }
		  });
      });

      this.showToolsCount(parentItem, null);

	  window.dataLayer.push({
		  event: 'click_icon',
		  click_icon: {
			  name: 'like',
			  area: 'body',
			  url: window.location.origin + newsUrl,
			  type: 'srdce',
		  },
		  _clear: true,
	  });
    }
  }

  putData = (bodyData) => {
    // eslint-disable-next-line no-undef
    fetch(window.location.origin + fragments.NEWS_PUT_SI, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/components/News.js